import { ManagementDetails } from 'app/components/core/management-details';
import { DomainDto, ParticipantDto, ScheduledBackupDto, type ScheduledValidatorBackupDto, ValidatorDto } from 'data';

interface BackupDetailsProps {
  backupsData?: ScheduledBackupDto | ScheduledValidatorBackupDto;
  scheduleBackupPath: string;
  backupHistoryPath: string;
  onRemove: () => void;
  isBackupRemoving: boolean;
  phase?: DomainDto.phase | ParticipantDto.phase | ValidatorDto.phase;
  isDisabled?: boolean;
}

export const backupScheduleOptions = {
  initialData: undefined,
  cacheTime: 0,
};

export const BackupDetails = ({
  backupsData,
  onRemove,
  isBackupRemoving,
  scheduleBackupPath,
  backupHistoryPath,
  phase,
  isDisabled = false,
}: BackupDetailsProps) => {
  return (
    <ManagementDetails
      title="Backups"
      schedulePath={scheduleBackupPath}
      scheduleData={backupsData}
      onRemove={onRemove}
      isRemoving={isBackupRemoving}
      phase={phase}
      showHistoryButton
      historyPath={backupHistoryPath}
      isDisabled={isDisabled}
      isScheduleDisabled={(data) => !!data?.nextRun || isDisabled}
      shouldShowAddIcon={(data) => !data?.nextRun && !isDisabled}
    />
  );
};
